let voucherTracking = (function () {
  function pushDataLayer(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload));
  }

  function init() {
    document
      .querySelectorAll('.tarif-voucher .be-validation-error')
      .forEach(function (errorElement) {
        const errorMessage = errorElement.textContent.trim();
        if (errorMessage) {
          pushDataLayer('error', { errors: [{ errorMessage: errorMessage }] });
        }
      });
  }

  window.addEventListener('load', init);

  return { init: init };
})();
